module.exports = __webpack_public_path__ + "img/shopify.a407467a.png";